export default __webpack_public_path__ + "static/media/glow.9e84592f.gif";